import { render, staticRenderFns } from "./presentation-sidebar-item.vue?vue&type=template&id=404aca6e&scoped=true&"
import script from "./presentation-sidebar-item.vue?vue&type=script&lang=js&"
export * from "./presentation-sidebar-item.vue?vue&type=script&lang=js&"
import style0 from "./presentation-sidebar-item.vue?vue&type=style&index=0&id=404aca6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404aca6e",
  null
  
)

export default component.exports